// extracted by mini-css-extract-plugin
module.exports = {"container":"i_Dr","item":"i_Ds","icon-only":"i_Dt","loading":"i_Du","action":"i_Dv"};